export const SEND_MESSAGE_TO_GEOBUS = 'SendMessageToGeobus';
export const SEND_HTTP_REQUEST = 'SendHttpRequest';
export const SEND_GENERIC_HTTP_REQUEST = 'SendGenericHttpRequest';
export const SEND_GEOBUS_HTTP_REQUEST = 'SendGeobusHttpRequest';
export const SEND_EMAIL = 'SendEmail';
export const SEND_EMAIL_WITH_REPORT = 'SendEmailWithReport';
export const CHANGE_STATUS_TO_ENTITY = 'ChangeStatusToEntity';
export const CREATE_PDF = "GeneratePDF";
export const CREATE_TEXT_FILE = "GenerateTextFile";
export const GENERATE_DATA = "GenerateData";
export const GENERATE_CUSTOM_LOGS = "GenerateCustomLogs";
export const EXTERNAL_FORM = "ExternalForm";
export const DATA_INTEGRATION = "DataIntegration";
export const PDF = 'pdf';
export const CSV = 'csv';
export const ZPL = 'zpl';
export const ZPL2 = 'zpl2';
export const DOCX = 'docx';
export const CALL_LABELS_MICRO_SERVICE = "CallLabelingService";
export const emailPattern = /(^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$)|(^@Model(\.[a-zA-Z_][a-zA-Z0-9_]*)*$)|(^<array values="(.*)"\/>$)|(^<emailArrayExtraData(.*)\/>$)/;
export const EXECUTE_SCRIPT = "ExecuteScript";
export const SCHEDULE_ACTION = "ScheduleAction"
